import React, { useState, useEffect, useRef } from "react";
import Navbar from "../Navbar/Navbar";
import CardSlider from "./CardSlider";
import About from "./About";
import './Home.css';
import Hstories from "../Hstories";
import Footer from "../Footer/Footer";
import axios from 'axios';
import loaderGif from "../loader-spin.gif";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PremiumMembership from "./PremiumMembership";
import Logo from "../rgt-matrimony-logo.png";
import { Link } from "react-router-dom";


const Home = () => {
  const [loading, setLoading] = useState(true);
  const [bannerList, setBannerList] = useState([]);

  useEffect(() => {
    const fetchBannerList = async () => {
      try {
        const response = await axios.get('https://tulirmatrimony.com/controlapi/bannerlist.php');
        setBannerList(response.data.body);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching banner list', error);
        setLoading(false);
      }
    };
    fetchBannerList();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <Navbar />
      {loading ? (
        <div
          className="d-flex justify-content-center tlr-back-spin"
          style={{ height: "100vh", alignItems: "center" }}
        >
          <img src={loaderGif} alt="Loading..." className="tlr-load-spin" />
        </div>
      ) : (
        <>
          {/* Hero Banner */}
          <section className="tlr-home-banner">
            <Slider {...settings}>
              {bannerList.map((banner) => (
                <div key={banner.id}>
                  <img
                    className="d-block w-100 tlr-banner-image"
                    style={{ height: "600px", objectFit: "cover" }}
                    src={banner.image}
                    alt={`Banner ${banner.id}`}
                  />
                </div>
              ))}
            </Slider>
          </section>

          {/* Card Slider Section */}
          <CardSlider />

          {/* About Section */}
          <About />

          {/* How It Works Section - NEW */}
          <HowItWorks />

          {/* Statistics Counter Section - NEW */}
          <StatisticsCounter />

          {/* Why Choose Us Section - NEW */}
          <WhyChooseUs />

          {/* Happy Stories Section */}
          <Hstories />

          {/* Premium Membership Section - NEW */}
          <PremiumMembership />

          {/* Testimonials Section - NEW */}
          <TestimonialsSection />

          {/* Download App Section - NEW */}
          <DownloadApp />

          {/* Call to Action Section - NEW */}
          <CallToAction />

          {/* Footer */}
          <Footer />
        </>
      )}
    </>
  );
};

// How It Works Component
const HowItWorks = () => {
  const steps = [
    {
      icon: "📝",
      title: "Register Free",
      description: "Create your profile with basic details and preferences",
      color: "#1e3c72"
    },
    {
      icon: "🔍",
      title: "Search & Discover",
      description: "Find matching profiles based on your criteria",
      color: "#f20487"
    },
    // {
    //   icon: "💬",
    //   title: "Connect & Chat",
    //   description: "Start conversations with interested matches",
    //   color: "#ff6b9d"
    // },
    {
      icon: "💍",
      title: "Find Your Match",
      description: "Begin your beautiful journey together",
      color: "#29335c"
    }
  ];

  return (
    <section className="tlr-how-it-works">
      <div className="tlr-container">
        <div className="tlr-section-header">
          <span className="tlr-section-badge">Simple Process</span>
          <h2 className="tlr-section-title">
            How <span className="tlr-gradient-text">It Works</span>
          </h2>
          <p className="tlr-section-subtitle">
            Find your perfect life partner in four simple steps
          </p>
        </div>
        <div className="tlr-steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="tlr-step-card">
              <div className="tlr-step-number">{String(index + 1).padStart(2, '0')}</div>
              <div className="tlr-step-icon" style={{ background: `linear-gradient(135deg, ${step.color}, ${step.color}cc)` }}>
                {step.icon}
              </div>
              <h3 className="tlr-step-title">{step.title}</h3>
              <p className="tlr-step-description">{step.description}</p>
              <div className="tlr-step-connector"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Statistics Counter Component
const StatisticsCounter = () => {
  const [counts, setCounts] = useState({
    couples: 0,
    members: 0,
    success: 0,
    cities: 0
  });

  useEffect(() => {
    const animateNumbers = () => {
      const targets = {
        couples: 1000,
        members: 5000,
        success: 98,
        cities: 50
      };

      const duration = 2000;
      const interval = 20;
      const steps = duration / interval;

      let step = 0;
      const timer = setInterval(() => {
        step++;
        const progress = step / steps;
        setCounts({
          couples: Math.floor(targets.couples * progress),
          members: Math.floor(targets.members * progress),
          success: Math.floor(targets.success * progress),
          cities: Math.floor(targets.cities * progress)
        });

        if (step >= steps) {
          clearInterval(timer);
        }
      }, interval);
    };

    animateNumbers();
  }, []);

  const stats = [
    { value: counts.couples, label: "Happy Couples", suffix: "+", icon: "💑" },
    { value: counts.members, label: "Trusted Members", suffix: "+", icon: "👥" },
    { value: counts.success, label: "Success Rate", suffix: "%", icon: "⭐" },
    { value: counts.cities, label: "Cities Covered", suffix: "+", icon: "🌆" }
  ];

  return (
    <section className="tlr-statistics">
      <div className="tlr-container">
        <div className="tlr-stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="tlr-stat-card">
              <div className="tlr-stat-icon">{stat.icon}</div>
              <div className="tlr-stat-value">
                {stat.value.toLocaleString()}{stat.suffix}
              </div>
              <div className="tlr-stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Why Choose Us Component - Enhanced with Shadows & Borders
// Why Choose Us Component - NEW with UNIQUE classnames
const WhyChooseUs = () => {
  const features = [
    {
      icon: "🔒",
      title: "100% Verified Profiles",
      description: "All profiles are verified for authenticity and security",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      color: "#667eea"
    },
    {
      icon: "🤝",
      title: "Trusted Matchmaking",
      description: "Years of experience in successful matchmaking",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      color: "#f093fb"
    },
    {
      icon: "💳",
      title: "Secure & Private",
      description: "Your privacy and data security is our priority",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      color: "#4facfe"
    },
    {
      icon: "🎯",
      title: "Personalized Matches",
      description: "AI-powered matching based on your preferences",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      color: "#43e97b"
    },
    {
      icon: "💬",
      title: "24/7 Support",
      description: "Dedicated customer support for your assistance",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      color: "#fa709a"
    },
    {
      icon: "📱",
      title: "Mobile Friendly",
      description: "Access your profile anytime, anywhere",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      color: "#a8edea"
    }
  ];

  return (
    <section className="new-why-choose-us">
      <div className="new-container">
        <div className="new-section-header">
          <span className="new-section-badge">Why Choose Us</span>
          <h2 className="new-section-title">
            The <span className="new-gradient-text">Tulir Advantage</span>
          </h2>
          <p className="new-section-subtitle">
            What makes us the preferred choice for finding your life partner
          </p>
        </div>
        <div className="new-features-grid">
          {features.map((feature, index) => (
            <div key={index} className="new-feature-card">
              <div className="new-feature-icon" style={{ background: feature.gradient }}>
                {feature.icon}
              </div>
              <h3 className="new-feature-title">{feature.title}</h3>
              <p className="new-feature-description">{feature.description}</p>
              <div className="new-feature-border" style={{ background: feature.gradient }}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
// Testimonials Component - Continuous Sliding Carousel
const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const carouselRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Ramesh & Priya",
      quote: "Tulir Matrimony மூலம் எங்கள் வாழ்க்கை துணையை எளிதாக கண்டுபிடித்தோம். மறக்க முடியாத அனுபவம்!",
      rating: 5,
      date: "March 2024",
      role: "Happy Couple",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      color: "#667eea",
      location: "Chennai"
    },
    {
      id: 2,
      name: "Karthik & Divya",
      quote: "மிகச் சிறந்த அனுபவம்! சரியான Patner கண்டுபிடிக்க இந்த தளம் உதவியது.",
      rating: 5,
      date: "February 2024",
      role: "Happy Couple",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      color: "#f093fb",
      location: "Coimbatore"
    },
    {
      id: 3,
      name: "Suresh & Lakshmi",
      quote: "அதிக expectation இல்லாமல் join பண்ணோம்… ஆனா நல்ல ஒரு வாழ்க்கை துணை கிடைத்தது.",
      rating: 5,
      date: "January 2024",
      role: "Happy Couple",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      color: "#4facfe",
      location: "Madurai"
    },
    {
      id: 4,
      name: "Venkat & Anjali",
      quote: "Simpleஆ use பண்ணலாம்… unnecessary complications இல்லாம இருந்தது நல்லா இருந்தது.",
      rating: 5,
      date: "December 2023",
      role: "Happy Couple",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      color: "#43e97b",
      location: "Bangalore"
    },
    {
      id: 5,
      name: "Manoj & Sowmya",
      quote: "ஒரு try பண்ணலாம்னு தான் join பண்ணேன்… ஆனா life settle ஆகிடுச்சு.",
      rating: 5,
      date: "November 2023",
      role: "Happy Couple",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      color: "#fa709a",
      location: "Hyderabad"
    },
    {
      id: 6,
      name: "Deepak & Meera",
      quote: "The support team was amazing throughout our journey. Highly recommended for everyone seeking their perfect life partner!",
      rating: 5,
      date: "October 2023",
      role: "Happy Couple",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      color: "#a8edea",
      location: "Mumbai"
    }
  ];

  // Duplicate testimonials for infinite loop effect
  const extendedTestimonials = [...testimonials, ...testimonials, ...testimonials];

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => {
          const nextIndex = prevIndex + 1;
          // Reset to middle when reaching the end of original set
          if (nextIndex >= testimonials.length * 2) {
            return testimonials.length;
          }
          return nextIndex;
        });
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
    // Resume auto-play after 10 seconds of inactivity
    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 10000);
  };

  const nextSlide = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => prev + 1);
    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 10000);
  };

  const prevSlide = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => prev - 1);
    setTimeout(() => {
      setIsAutoPlaying(true);
    }, 10000);
  };

  const getVisibleTestimonials = () => {
    const items = [];
    for (let i = -1; i <= 1; i++) {
      const index = (currentIndex + i + extendedTestimonials.length) % extendedTestimonials.length;
      items.push({
        ...extendedTestimonials[index],
        position: i,
        key: `${index}-${currentIndex}`
      });
    }
    return items;
  };

  const visibleTestimonials = getVisibleTestimonials();

  return (
    <section className="tlr-testimonials-modern">
      <div className="tlr-container">
        <div className="tlr-section-header">
          <span className="tlr-section-badge testimonial-badge">Love Stories</span>
          <h2 className="tlr-section-title modern-title">
            What Our <span className="tlr-gradient-text-multi">Couples</span> Say
          </h2>
          <p className="tlr-section-subtitle modern-subtitle">
            Real stories from couples who found their soulmate with us
          </p>
        </div>

        <div className="tlr-carousel-container">
          <button className="tlr-carousel-nav tlr-carousel-prev" onClick={prevSlide}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          <div className="tlr-carousel-track" ref={carouselRef}>
            <div className="tlr-carousel-slides">
              {visibleTestimonials.map((testimonial) => (
                <div 
                  key={testimonial.key} 
                  className={`tlr-carousel-slide tlr-carousel-slide-${testimonial.position === 0 ? 'center' : (testimonial.position === -1 ? 'left' : 'right')}`}
                >
                  <div className="tlr-testimonial-card-modern" style={{ '--testimonial-color': testimonial.color }}>
                    <div className="tlr-testimonial-bg-pattern"></div>
                    <div className="tlr-quote-icon-modern" style={{ color: testimonial.color }}>“</div>
                    <div className="tlr-testimonial-content">
                      <p className="tlr-testimonial-quote-modern">"{testimonial.quote}"</p>
                      <div className="tlr-rating-modern">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <span key={i} className="star-filled">★</span>
                        ))}
                      </div>
                      <div className="tlr-testimonial-author">
                        <div className="tlr-author-avatar" style={{ background: testimonial.gradient }}>
                          {testimonial.name.charAt(0)}
                        </div>
                        <div className="tlr-author-info">
                          <h4 className="tlr-testimonial-name-modern">{testimonial.name}</h4>
                          <span className="tlr-testimonial-role">{testimonial.role}</span>
                          <div className="tlr-testimonial-meta">
                            <span className="tlr-testimonial-date-modern">{testimonial.date}</span>
                            <span className="tlr-testimonial-location">• {testimonial.location}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tlr-testimonial-deco" style={{ background: testimonial.gradient }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button className="tlr-carousel-nav tlr-carousel-next" onClick={nextSlide}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="tlr-carousel-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`tlr-carousel-dot ${Math.floor(currentIndex % testimonials.length) === index ? 'active' : ''}`}
              onClick={() => goToSlide(index + testimonials.length)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

// Download App Component
const DownloadApp = () => {
  return (
    <section className="tlr-download-app">
      <div className="tlr-container">
        <div className="tlr-app-content">
          <div className="tlr-app-left">
            <span className="tlr-app-badge">Coming Soon</span>
            <h2 className="tlr-app-title">
              Download the <span className="tlr-gradient-text1">Tulir Matrimony</span> App
            </h2>
            <p className="tlr-app-description">
              Find your perfect match on the go. Get instant notifications,
              chat with matches, and manage your profile from anywhere.
            </p>
            <div className="tlr-app-buttons">
              <button className="tlr-app-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 8H6C4.89543 8 4 8.89543 4 10V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V10C20 8.89543 19.1046 8 18 8Z" stroke="currentColor" strokeWidth="1.5" />
                  <path d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z" stroke="currentColor" strokeWidth="1.5" />
                  <path d="M8 4L12 8L16 4" stroke="currentColor" strokeWidth="1.5" />
                </svg>
                <span>Google Play</span>
              </button>
              <button className="tlr-app-btn">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z" stroke="currentColor" strokeWidth="1.5" />
                  <path d="M12 8V12L14 14" stroke="currentColor" strokeWidth="1.5" />
                </svg>
                <span>App Store</span>
              </button>
            </div>
          </div>
          <div className="tlr-app-right">
            <div className="tlr-app-mockup">
              <div className="tlr-mockup-screen">
              <img src={Logo} className="tlr-navbar-logo" alt="Tulir Matrimony" />
                {/* <div className="tlr-mockup-content">
                  <span>❤️</span>
                  <span>Tulir</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Call to Action Component
const CallToAction = () => {
  return (
    <section className="tlr-cta">
      <div className="tlr-container">
        <div className="tlr-cta-content">
          <h2 className="tlr-cta-title">Start Your Journey Today</h2>
          <p className="tlr-cta-description">
            Join thousands of happy couples who found their perfect match with Tulir Matrimony
          </p>
          <div className="tlr-cta-buttons">
            <Link to="/Freereg" className="tlr-cta-btn-primary">Register for Free</Link>
            {/* <button className="tlr-cta-btn-secondary">Contact Us</button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;